



































































import { computed, defineComponent, onMounted, onUnmounted, ref, getCurrentInstance } from '@vue/composition-api';
import { SubmitContext } from 'tdesign-vue';
import _ from 'lodash';
import BaseSelect from '@/renderer/components/Base/BaseSelect/BaseSelect.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import {
  BUSINESS_OPTIONS,
  POSITION_OPTIONS,
  SCALE_OPTIONS,
} from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import tips from '@/renderer/scripts/utils/tips';
import ipc from '@/renderer/scripts/utils/ipc';
import store from '@/renderer/store';
import smh from '@/renderer/scripts/smh';
import infoHeader from '@/renderer/assets/images/dialog/info-header.svg';
const initdata = () => {
  return {
    business: '',
    orgName: '',
    role: '',
    scale: '',
  };
};
export default defineComponent({
  name: 'UserSurveyDialog',
  components: {
    BaseSelect,
  },
  setup() {
    const { isInWeMeetApp } = store.getters;
    const formData = ref(initdata());
    const businessOptions = ref(_.cloneDeep(BUSINESS_OPTIONS));
    const scaleOptions = ref(_.cloneDeep(SCALE_OPTIONS));
    const positionOptions = ref(_.cloneDeep(POSITION_OPTIONS));
    const innerShow = ref<boolean>(false);
    const canEditOrgName = ref(false);
    const mode = ref(isInWeMeetApp ? 'meeting' : 'enterprise'); // 会议模式 & 企业模式（enterprise）
    const customObj = computed(() => {
      if (formData.value.business) {
        for (const obj of businessOptions.value) {
          if (obj.value === formData.value.business) {
            return {
              subTitleText: obj.description,
              titleBg: obj.icon,
            };
          }
        }
      }
      return {
        subTitleText: i18n_t('获取专属行业解决方案'),
        titleBg: '',
      };
    });
    const rules = {
      business: [
        {
          required: true,
          message: i18n_t('必填'),
          type: 'error',
        },
      ],
      orgName: [
        {
          required: true,
          message: i18n_t('必填'),
          type: 'error',
        },
        {
          validator: (val: string) => val.length <= 24,
          message: i18n_t('字数不得超过24字'),
          type: 'error',
        },
        {
          whitespace: true,
          message: i18n_t('值不能为空'),
        },
      ],
    };
    const methods = {
      open(flag = false) {
        canEditOrgName.value = flag;
        formData.value = initdata();
        innerShow.value = true;
        reporter.report('manager_new_guide', {
          message_show: 'show',
        });
      },
      close() {
        innerShow.value = false;
      },
      industryOptionOnConfirm(value: string) {
        const flag = businessOptions.value.some(item => item.value === value);
        if (flag) {
          return tips.error(i18n_t('该行业已存在'));
        }
        businessOptions.value.push({
          label: value,
          value,
          description: i18n_t('一站式企业文件管理协作平台'),
          icon: 'common-use',
          isCreated: true,
        });
      },
      positionOptionOnConfirm(value: string) {
        const flag = positionOptions.value.some(item => item.value === value);
        if (flag) {
          return tips.error(i18n_t('该职位已存在'));
        }
        positionOptions.value.push({
          label: value,
          value,
        });
      },
      onSubmit(e: SubmitContext<FormData>) {
        const { validateResult } = e;
        if (validateResult === true) {
          if (mode.value === 'meeting') {
            this.sumbitSurvey(true);
          } else {
            this.sumbitSurvey(false);
          }
          reporter.report('manager_new_guide', {
            industry: formData.value.business,
            company_name: formData.value.orgName,
            position: formData.value.role,
            scale: formData.value.scale,
          });
        }
      },
      async sumbitSurvey(addFlag: boolean) {
        try {
          await smh.userAPI.createSurvey({
            type: 'create-industry-info',
            data: {
              ...formData.value,
            },
            addFlag, // 用于标识用户是否需要赠送5G
          });

          innerShow.value = false;
          if (addFlag) {
            tips.success(i18n_t('领取成功'));
            ipc.emit(ipc.RENDERER_EVENTS_MAP.SHOW_USER_SURVEY_RESULT);
          } else {
            tips.success(i18n_t('提交成功'));
            ipc.emit(ipc.RENDERER_EVENTS_MAP.SHOW_INVITE_DIALOG, { showGuidePopup: true });
          }
          await store.dispatch('GetOrgInfo', store.getters.orgId);
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
    };
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.START_USER_SURVEY, methods.open);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.START_USER_SURVEY, methods.open);
    });
    return {
      infoHeader,
      innerShow,
      formData,
      rules,
      businessOptions,
      scaleOptions,
      positionOptions,
      customObj,
      mode,
      ...methods,
    };
  },
});
